import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import NetflixTitle from './NetflixTitle';
import ProfilePage from './profilePage/profilePage';
import Browse from './browse/browse';
// import WorkPermit from './pages/WorkPermit';
import WorkExperience from './pages/WorkExperience';
// import Recommendations from './pages/Recommendations';
import Skills from './pages/Skills';
import Projects from './pages/Projects';
import ContactMe from './pages/ContactMe';
import Layout from './Layout';
// import Music from './pages/Music';
import Hobbies from './pages/Hobbies';
import Reading from './pages/Reading';
import SideQuests from './pages/SideQuests';
// import Blogs from './pages/Blogs';
import Certifications from './pages/Certifications';

const App: React.FC = () => {
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<NetflixTitle />} />
      <Route path="/browse" element={<Browse />} />
      <Route path="/profile/:profileName" element={<Layout><ProfilePage /></Layout>} />
      {/* <Route path="/work-permit" element={<Layout><WorkPermit /></Layout>} /> */}
      <Route path="/work-experience" element={<Layout><WorkExperience /></Layout>} />
      {/* <Route path="/recommendations" element={<Layout><Recommendations /></Layout>} /> */}
      <Route path="/skills" element={<Layout><Skills /></Layout>} />
      <Route path="/projects" element={<Layout><Projects /></Layout>} />
      <Route path="/contact-me" element={<Layout><ContactMe /></Layout>} />
      <Route path="/hobbies" element={<Layout><Hobbies /></Layout>} />
      {/* Legacy route redirect for bookmarks */}
      <Route path="/music" element={<Layout><Hobbies /></Layout>} />
      <Route path="/side-quests" element={<Layout><SideQuests /></Layout>} />
      <Route path="/reading" element={<Layout><Reading /></Layout>} />
      {/* <Route path="/blogs" element={<Layout><Blogs /></Layout>} /> */}
      <Route path="/certifications" element={<Layout><Certifications /></Layout>} />
    </Routes>
    </>
  );
};

export default App;
